import {
  type Fn,
  sleep,
  withConcurrency,
  type Action,
  action,
} from "@reatom/framework";

export const withDebounce =
  <T extends Action>(ms: number): Fn<[T], T> =>
  (origin) => {
    const debounced = action(
      async (ctx, ...payload) => {
        await ctx.schedule(() => sleep(ms));
        return origin(ctx, ...payload);
      },
      `${origin.__reatom?.name || origin.name || "action"}.debounced(${ms})`,
    ).pipe(withConcurrency());

    return Object.assign(debounced, origin);
  };
